import React from 'react'
import '../styles/Footer.css'
import { FaInstagram } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer footer-center bg-secondary flex flex-col items-center">
      <div className="flex flex-col">
      <div className="flex flex-row items-center text-white">
        <p>© 2024 Circe's Forge</p>
        <p>All Rights Reserved</p>
        <p>Made with 🤍 by Circe</p>
        <a href="https://www.instagram.com/circesforge/" target="_blank" rel="noopener noreferrer" className="mr-4">
                    <FaInstagram size={24} />
        </a>
      </div>
        <img
          src={process.env.PUBLIC_URL + "/pageElements/gold_logo-01.png" }
          alt="Circe alt logo" 
          className="flex justify-center h-[100px]"
        ></img>
      <div className="flex flex-row items-center text-white">
        <p>Are you the owner?</p>
        <Link to="/admin">Click here</Link> 
      </div>
      </div>
      
    </footer>
  )
}

export default Footer
